document.addEventListener("DOMContentLoaded", function () {
  const newsletterForm = document.querySelector("#newsletter-form");

  if (newsletterForm) {
    newsletterForm.addEventListener("submit", async function (event) {
      event.preventDefault();

      const honeypot = newsletterForm.querySelector("#number").value;
      if (honeypot) {
        console.log("Spam detected!");
        return;
      }

      const emailInput = newsletterForm.querySelector("#newsletter-email");
      const statusMessage = newsletterForm.querySelector(
        ".newsletter-success-message"
      );

      const options = {
        method: "POST",
        headers: {
          revision: "2024-02-15",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Newsletter Form",
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput.value,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "Y2vgpn",
                },
              },
            },
          },
        }),
      };

      try {
        const response = await fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=Uf5JBs",
          options
        );

        if (response.ok) {
          statusMessage.classList.remove("d-none");
          newsletterForm.reset();
        } else {
          const { errors } = await response.json();
          console.error("Error:", errors);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    });
  }
});
